/*
 *                     NOTICE
 *            COPYRIGHT 2020 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { GuidedExpressionSummaryReadOnlyGenerator } from "abreact/expression/ui/editor/readonly/GuidedExpressionSummaryReadOnlyGenerator";
import { DefaultOperandValueValueRenderer } from "abreact/expression/ui/editor/readonly/OperandValueValueRenderer";
// import OperandValue = GuidedExpressionEditor.AbstractModel.AbstractRowModel.OperandValue;

export class OperandValueSummaryGeneratorImpl {
  createRichExpressionSummary(definition, summaryType, expressionDomainModel, isTemplate) {
    return this.createSummaryGenerator(expressionDomainModel).generateRichSummary(definition);
  }
  createStringExpressionSummary(definition, summaryType, singleLine, expressionDomainModel, isTemplate) {
    return this.createSummaryGenerator(expressionDomainModel).generateStringSummary(definition, undefined, singleLine);
  }
  createRichSummary(operandValue, summaryType, expressionDomainModel, leafNodeOperatorID) {
    return this.createSummaryGenerator(expressionDomainModel).generateRichSummaryForNode(operandValue.toExpExpressionNode(), leafNodeOperatorID);
  }
  createSummaryGenerator(expressionDomainModel) {
    let generator = new GuidedExpressionSummaryReadOnlyGenerator(expressionDomainModel, this.getValueRenderer(expressionDomainModel));
    return generator;
  }
  getValueRenderer(expressionDomainModel) {
    return new DefaultOperandValueValueRenderer(expressionDomainModel);
  }
  createStringConditionSummary(expExpressionNode, summaryType, expressionDomainModel, isTemplate) {
    let summary = this.createSummaryGenerator(expressionDomainModel).generateStringSummaryForNode(expExpressionNode, undefined, true);
    return summary;
  }
  createRichConditionSummary(expExpressionNode, summaryType, expressionDomainModel, isTemplate) {
    let summary = this.createSummaryGenerator(expressionDomainModel).generateRichSummaryForNode(expExpressionNode);
    return summary;
  }

  //@ts-ignore unusedLocals
  createStringSummary(operandValue,
  //@ts-ignore unusedLocals
  summaryType, singleLine,
  //@ts-ignore unusedLocals
  expressionDomainModel, argumentOperand, includeAdvanced) {
    let summary = this.createSummaryGenerator(expressionDomainModel).generateStringSummaryForNode(operandValue.toExpExpressionNode(), undefined, singleLine);
    return summary;
  }
}
//# sourceMappingURL=OperandValueSummaryGeneratorImpl.js.map
